import { render, staticRenderFns } from "./OK.vue?vue&type=template&id=4a52e3f0&scoped=true&"
import script from "./OK.vue?vue&type=script&lang=js&"
export * from "./OK.vue?vue&type=script&lang=js&"
import style0 from "./OK.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OK.vue?vue&type=style&index=1&id=4a52e3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52e3f0",
  null
  
)

export default component.exports